module.exports = __webpack_public_path__ + "static/media/skyline_supported.a61efb24.png";